interface Props {
  title: string;
  description?: string;
}

export default function PageHero({ title, description }: Props) {
  return (
    <section className="pt-32 pb-16 md:pt-40 md:pb-20 border-b border-border">
      <div className="max-w-content mx-auto px-6 md:px-12">
        <h1 className="text-display-sm md:text-display font-serif">{title}</h1>
        {description && (
          <p className="mt-5 text-secondary text-lg md:text-xl max-w-2xl">{description}</p>
        )}
      </div>
    </section>
  );
}
